import _ from 'lodash'
import { baseURL, formatFetchError, fetchHeaders } from '../util'
import { Api, Vehicle } from '@cruz-com/lookup'

export async function detail(id: string | any): Promise<Api.Result<Vehicle.Detail>> {
  try {
    const res = await fetch(`${baseURL}/vehicle/detail?id=${id}`, {
      method: 'GET',
      headers: await fetchHeaders(),
      next: { revalidate: 5 },
      cache: 'no-store'
    })
    const d: Api.Result<Vehicle.Detail> = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}